export default "__VITE_ASSET__4dfdd722__"